
export default {
    props: ['loading', 'value', 'disabled', 'valid', 'generatedKey'],
    methods: {
        copy() {
            navigator.clipboard.writeText(this.generatedKey);
        },
    },
};
